import { usePrevious } from "@common/lib/hooks";
import React from "react";
import { type Location, useLocation } from "react-router-dom";

export const useOnNavigate = (cb: (location: Location) => void) => {
  const location = useLocation();
  const prevLocation = usePrevious(location);

  React.useEffect(() => {
    if (!prevLocation || (prevLocation.pathname === location.pathname && prevLocation.search === location.search))
      return;

    cb(location);
  }, [location, prevLocation, cb]);
};
